module.exports = __webpack_public_path__ + "media/aloe-small.0524940d.mp4";